import { environment } from './../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { GetTokenService, UserDetailsService } from '../core/clientV2';

export interface UserDetail {
    id?: number;
    username?: string;
    email?: string;
    first_name?: string;
    last_name?: string;
}

export interface AuthToken {
    token: string;
}

interface RequestOptions {
    headers: HttpHeaders;
}

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
    private tokenSubject: BehaviorSubject<AuthToken | null>;
    public token$: Observable<AuthToken | null>;

    private currentUserSubject: BehaviorSubject<UserDetail | null>;
    public currentUser$: Observable<UserDetail | null>;
    private options: RequestOptions;

    constructor(private http: HttpClient, private auth: GetTokenService, private user: UserDetailsService) {
        this.tokenSubject = new BehaviorSubject<AuthToken | null>(JSON.parse(localStorage.getItem('token') ?? 'null'));
        this.token$ = this.tokenSubject.asObservable();

        this.currentUserSubject = new BehaviorSubject<UserDetail | null>(JSON.parse(localStorage.getItem('currentUser') ?? 'null'));
        this.currentUser$ = this.currentUserSubject.asObservable();
    }

    public get tokenValue(): AuthToken {
        return this.tokenSubject.value!;
    }

    public get currentUserValue(): UserDetail | null {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        return this.http.post<AuthToken>(`${environment.api2Url}/get-token/`, {"username": username, "password": password}).pipe(
            tap((token) => {
                localStorage.setItem('token', JSON.stringify(token));
                this.tokenSubject.next(token);
            })
        )
    }

    getUserData() {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Token ${this.tokenValue.token}`
        });
        this.options = { headers: headers };

        return this.http.get<UserDetail>(`${environment.api2Url}/user-details/`, this.options as Parameters<typeof this.http.get>[1]).pipe(
            tap((userDetail) => {
                localStorage.setItem('currentUser', JSON.stringify(userDetail));
                this.currentUserSubject.next(userDetail)
            })
        );
    }

    logout() {
        localStorage.removeItem('token');
        localStorage.removeItem('currentUser');
        this.tokenSubject.next(null);
    }
}